import React, { useRef, useState } from 'react';

import styled from 'styled-components';

import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { NavBar } from 'apps/auth/components/common/Layout/NavBar/NavBar';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { Text } from 'apps/auth/components/common/Text/Text';

const SkipWrapper = styled.div`
    pointer-events: auto;
    cursor: pointer;
    display: flex;
    align-items: center;
`;
const STEP = 1;
const QUANTITY_SKIP = 1;

const OowModal = (props) => {
    const { arrayQuestions = [], skipMessage = '', maxAnswers = arrayQuestions.length - QUANTITY_SKIP } = props;

    const arrayRef = useRef([...arrayQuestions]);
    const [counter, setCounter] = useState(0);
    const [curQuestion, setCurQuestion] = useState(arrayRef.current[counter]);
    const [result, setResult] = useState({});
    const [isNotSkip, setSkip] = useState(true);

    const forward = (variant) => {
        const answer = {
            [curQuestion.id]: {
                value: variant.value,
                canonicalPath: `toValues[${curQuestion.id}]`,
            },
        };
        calcResult(answer, curQuestion.id);
        if (counter < maxAnswers - STEP) {
            setQuestion(counter + STEP);
        } else {
            const newResult = { ...result, ...answer };
            props.onClickQuestions(newResult);
        }
    };

    const calcResult = (answer, id) => {
        setResult((prevState) => {
            const currentIndex = Object.keys(prevState).findIndex((el) => id === Number(el));
            if (currentIndex !== -1) {
                return {
                    ...prevState,
                    [id]: {
                        ...prevState[id],
                        value: answer[id].value,
                    },
                };
            } else {
                return { ...prevState, ...answer };
            }
        });
    };

    const skipQuestion = (count) => {
        setSkip(false);
        arrayRef.current.splice(count, 1);
        setCounter(count);
        setCurQuestion(arrayRef.current[count]);
    };

    const setQuestion = (newCounter) => {
        setCounter(newCounter);
        setCurQuestion(arrayRef.current[newCounter]);
    };
    const back = () => {
        if (counter > 0) {
            setQuestion(counter - STEP);
        }
    };

    const renderVariant = (arrayVariant) => {
        return arrayVariant.map((variant) => {
            const { text, value } = variant;
            if (value !== '6') {
                return (
                    <Row key={text + value} indent="adaptive-16-24">
                        <Panel onClick={() => forward(variant)} isBordered hasBorderRadius isHoverable>
                            <Text>{text}</Text>
                        </Panel>
                    </Row>
                );
            }
        });
    };

    const renderIcon = (count) => {
        if (count === 0) {
            return (
                <DiskButton
                    iconName="cross"
                    to="#"
                    onClick={(e) => {
                        e.preventDefault();
                        props.onClick();
                    }}
                />
            );
        } else {
            return <DiskButton iconName="arrow-back" to="#" onClick={back} />;
        }
    };

    return (
        <>
            <HeaderPanel title={curQuestion.question} />
            {renderVariant(curQuestion.variantBean)}
            <NavBar align="space-between">
                {renderIcon(counter)}
                {isNotSkip && (
                    <SkipWrapper onClick={() => skipQuestion(counter)}>
                        <span>{skipMessage}</span>
                    </SkipWrapper>
                )}
            </NavBar>
        </>
    );
};
export default OowModal;
